// Rich Arabic learning content — designed for non-Arab speakers.
// Each letter shows all four positional forms + 4 example Qur'anic words.
// Each verb shows a full conjugation across 8 persons.
// Each grammar topic ships with multiple examples, not just one.

// ─── 28 letters ─────────────────────────────────────────────────────────
// [letter, name, transliteration, isolated, initial, medial, final, [example words: [ar, tr, en] × 8+]]
// Vocabulary follows Dr. V. Abdur Rahim's Madinah Arabic Book 1 style
// (the world reference for teaching Arabic to non-Arab speakers).
export const LETTERS = [
  ["ا","Alif","ā / '","ا","ا","ـا","ـا",[
    ["أَحَد","aḥad","One"], ["أَبٌ","ab","Father"], ["أُمّ","umm","Mother"], ["إِمَام","imām","Leader"],
    ["أَخ","akh","Brother"], ["أُخْت","ukht","Sister"], ["إِنسَان","insān","Human being"], ["أَمَل","amal","Hope"],
  ]],
  ["ب","Bāʼ","b","ب","بـ","ـبـ","ـب",[
    ["بَاب","bāb","Door"], ["بَيْت","bayt","House"], ["كِتَاب","kitāb","Book"], ["حَبِيب","ḥabīb","Beloved"],
    ["بَحْر","baḥr","Sea"], ["بَقَرَة","baqarah","Cow"], ["بَرَكَة","barakah","Blessing"], ["أَب","ab","Father"],
  ]],
  ["ت","Tāʼ","t","ت","تـ","ـتـ","ـت",[
    ["تَاج","tāj","Crown"], ["تِين","tīn","Fig"], ["تَمْر","tamr","Dates"], ["تِلْمِيذ","tilmīdh","Student"],
    ["تُفَّاح","tuffāḥ","Apple"], ["بِنْت","bint","Girl"], ["كِتَاب","kitāb","Book"], ["بَيْت","bayt","House"],
  ]],
  ["ث","Thāʼ","th (think)","ث","ثـ","ـثـ","ـث",[
    ["ثَلَاثَة","thalāthah","Three"], ["ثَوْب","thawb","Garment"], ["ثَعْلَب","thaʿlab","Fox"], ["مِيرَاث","mīrāth","Inheritance"],
    ["حَدِيث","ḥadīth","Ḥadīth"], ["ثَمَرَة","thamarah","Fruit"], ["ثَقِيل","thaqīl","Heavy"], ["ثُلُث","thuluth","One third"],
  ]],
  ["ج","Jīm","j","ج","جـ","ـجـ","ـج",[
    ["جَبَل","jabal","Mountain"], ["جَنَّة","jannah","Paradise"], ["مَسْجِد","masjid","Mosque"], ["حَاجّ","ḥājj","Pilgrim"],
    ["جَمَل","jamal","Camel"], ["جَدِيد","jadīd","New"], ["جَمِيل","jamīl","Beautiful"], ["رَجُل","rajul","Man"],
  ]],
  ["ح","Ḥāʼ","ḥ (deep)","ح","حـ","ـحـ","ـح",[
    ["حَجّ","ḥajj","Pilgrimage"], ["حَلِيب","ḥalīb","Milk"], ["رَحْمَة","raḥmah","Mercy"], ["صُلْح","ṣulḥ","Peace"],
    ["حَقّ","ḥaqq","Truth"], ["حِمَار","ḥimār","Donkey"], ["مَحَبَّة","maḥabbah","Love"], ["فَتْح","fatḥ","Opening / conquest"],
  ]],
  ["خ","Khāʼ","kh (loch)","خ","خـ","ـخـ","ـخ",[
    ["خُبْز","khubz","Bread"], ["خَيْر","khayr","Good"], ["أَخ","akh","Brother"], ["تَارِيخ","tārīkh","History"],
    ["خَاتَم","khātam","Ring / seal"], ["خَيْمَة","khaymah","Tent"], ["مَخْرَج","makhraj","Exit"], ["أُخْت","ukht","Sister"],
  ]],
  ["د","Dāl","d","د","د","ـد","ـد",[
    ["دَار","dār","Home"], ["دِين","dīn","Religion"], ["وَلَد","walad","Boy"], ["يَد","yad","Hand"],
    ["دَجَاجَة","dajājah","Chicken"], ["دَرْس","dars","Lesson"], ["أَحَد","aḥad","One"], ["حَدِيقَة","ḥadīqah","Garden"],
  ]],
  ["ذ","Dhāl","dh (this)","ذ","ذ","ـذ","ـذ",[
    ["ذَهَب","dhahab","Gold"], ["ذِكْر","dhikr","Remembrance"], ["أُذُن","udhun","Ear"], ["أُسْتَاذ","ustādh","Teacher"],
    ["ذَنْب","dhanb","Sin"], ["ذَكِيّ","dhakiyy","Intelligent"], ["ذِئْب","dhi'b","Wolf"], ["نَبِيذ","nabīdh","Nabidh drink"],
  ]],
  ["ر","Rāʼ","r (rolled)","ر","ر","ـر","ـر",[
    ["رَبّ","rabb","Lord"], ["رَحِيم","raḥīm","Merciful"], ["نُور","nūr","Light"], ["قَمَر","qamar","Moon"],
    ["رَجُل","rajul","Man"], ["رِيح","rīḥ","Wind"], ["رَسُول","rasūl","Messenger"], ["مَطَر","maṭar","Rain"],
  ]],
  ["ز","Zāy","z","ز","ز","ـز","ـز",[
    ["زَمَن","zaman","Time"], ["زَهْرَة","zahrah","Flower"], ["زَيْت","zayt","Oil"], ["عَزِيز","ʿazīz","Mighty"],
    ["زَوْج","zawj","Spouse"], ["زَكَاة","zakāh","Zakāt"], ["مِيزَان","mīzān","Scale"], ["خُبْز","khubz","Bread"],
  ]],
  ["س","Sīn","s","س","سـ","ـسـ","ـس",[
    ["سَلَام","salām","Peace"], ["سَمَاء","samā'","Sky"], ["سَاعَة","sāʿah","Hour"], ["دَرْس","dars","Lesson"],
    ["سَيْف","sayf","Sword"], ["سَرِير","sarīr","Bed"], ["مَسْجِد","masjid","Mosque"], ["نَاس","nās","People"],
  ]],
  ["ش","Shīn","sh","ش","شـ","ـشـ","ـش",[
    ["شَمْس","shams","Sun"], ["شَهْر","shahr","Month"], ["شَجَرَة","shajarah","Tree"], ["عَرْش","ʿarsh","Throne"],
    ["شَاي","shāy","Tea"], ["شَارِع","shāriʿ","Street"], ["مِشْمِش","mishmish","Apricot"], ["فِرَاش","firāsh","Bedding"],
  ]],
  ["ص","Ṣād","ṣ (heavy s)","ص","صـ","ـصـ","ـص",[
    ["صَلَاة","ṣalāh","Prayer"], ["صَبْر","ṣabr","Patience"], ["صَدِيق","ṣadīq","Friend"], ["نَصْر","naṣr","Victory"],
    ["صَيْف","ṣayf","Summer"], ["صَبَاح","ṣabāḥ","Morning"], ["صَحَابَة","ṣaḥābah","Companions"], ["فُصْحَى","fuṣḥā","Standard Arabic"],
  ]],
  ["ض","Ḍād","ḍ (heavy d)","ض","ضـ","ـضـ","ـض",[
    ["ضَوْء","ḍaw'","Light"], ["ضَيْف","ḍayf","Guest"], ["أَرْض","arḍ","Earth"], ["فَرْض","farḍ","Obligation"],
    ["ضِدّ","ḍidd","Opposite"], ["مَرِيض","marīḍ","Sick person"], ["رَمَضَان","ramaḍān","Ramaḍān"], ["بَيْضَة","bayḍah","Egg"],
  ]],
  ["ط","Ṭāʼ","ṭ (heavy t)","ط","طـ","ـطـ","ـط",[
    ["طَرِيق","ṭarīq","Road"], ["طَعَام","ṭaʿām","Food"], ["طِفْل","ṭifl","Child"], ["خَطّ","khaṭṭ","Line / script"],
    ["طَبِيب","ṭabīb","Doctor"], ["طَائِر","ṭā'ir","Bird"], ["بَطْن","baṭn","Belly"], ["فِطْر","fiṭr","Breaking fast"],
  ]],
  ["ظ","Ẓāʼ","ẓ (heavy dh)","ظ","ظـ","ـظـ","ـظ",[
    ["ظَهْر","ẓahr","Back / noon"], ["ظُلْم","ẓulm","Injustice"], ["ظِلّ","ẓill","Shade"], ["حِفْظ","ḥifẓ","Memorisation"],
    ["ظَنّ","ẓann","Assumption"], ["ظَاهِر","ẓāhir","Apparent"], ["نَظَر","naẓar","Look / vision"], ["عَظِيم","ʿaẓīm","Great"],
  ]],
  ["ع","ʿAyn","ʿ (throat)","ع","عـ","ـعـ","ـع",[
    ["عِلْم","ʿilm","Knowledge"], ["عَيْن","ʿayn","Eye / spring"], ["عَرَبِيّ","ʿarabiyy","Arab"], ["رُكُوع","rukūʿ","Bowing"],
    ["عَبْد","ʿabd","Servant"], ["عَسَل","ʿasal","Honey"], ["مُعَلِّم","muʿallim","Teacher"], ["جَامِع","jāmiʿ","Congregational mosque"],
  ]],
  ["غ","Ghayn","gh (gargled r)","غ","غـ","ـغـ","ـغ",[
    ["غَيْم","ghaym","Cloud"], ["غَنِيّ","ghaniyy","Rich"], ["مَغْرِب","maghrib","Sunset"], ["بُلُوغ","bulūgh","Puberty"],
    ["غَدَاء","ghadā'","Lunch"], ["غُرْفَة","ghurfah","Room"], ["صَغِير","ṣaghīr","Small"], ["فَرَاغ","farāgh","Free time"],
  ]],
  ["ف","Fāʼ","f","ف","فـ","ـفـ","ـف",[
    ["فَجْر","fajr","Dawn"], ["فِطْر","fiṭr","Breaking fast"], ["فَاكِهَة","fākihah","Fruit"], ["خَوْف","khawf","Fear"],
    ["فَم","fam","Mouth"], ["فِيل","fīl","Elephant"], ["مِفْتَاح","miftāḥ","Key"], ["ضَيْف","ḍayf","Guest"],
  ]],
  ["ق","Qāf","q (uvular)","ق","قـ","ـقـ","ـق",[
    ["قُرْآن","qur'ān","Qur'an"], ["قَلْب","qalb","Heart"], ["قَمَر","qamar","Moon"], ["حَقّ","ḥaqq","Truth"],
    ["قَلَم","qalam","Pen"], ["قَهْوَة","qahwah","Coffee"], ["صَادِق","ṣādiq","Truthful"], ["سَبَق","sabaq","Preceded"],
  ]],
  ["ك","Kāf","k","ك","كـ","ـكـ","ـك",[
    ["كِتَاب","kitāb","Book"], ["كَلْب","kalb","Dog"], ["مَلِك","malik","King"], ["فِكْر","fikr","Thought"],
    ["كُرْسِيّ","kursiyy","Chair"], ["كَبِير","kabīr","Big"], ["مَكَّة","makkah","Makkah"], ["سَمَك","samak","Fish"],
  ]],
  ["ل","Lām","l","ل","لـ","ـلـ","ـل",[
    ["لَيْل","layl","Night"], ["لِسَان","lisān","Tongue"], ["قَلْب","qalb","Heart"], ["عَقْل","ʿaql","Mind"],
    ["لَبَن","laban","Yoghurt"], ["لَوْن","lawn","Colour"], ["حَلَال","ḥalāl","Ḥalāl"], ["جَمِيل","jamīl","Beautiful"],
  ]],
  ["م","Mīm","m","م","مـ","ـمـ","ـم",[
    ["مَاء","mā'","Water"], ["مَسْجِد","masjid","Mosque"], ["أُمّ","umm","Mother"], ["إِسْلَام","islām","Islam"],
    ["مَدِينَة","madīnah","City / Madinah"], ["مِفْتَاح","miftāḥ","Key"], ["قَلَم","qalam","Pen"], ["يَوْم","yawm","Day"],
  ]],
  ["ن","Nūn","n","ن","نـ","ـنـ","ـن",[
    ["نُور","nūr","Light"], ["نَبِيّ","nabiyy","Prophet"], ["جَنَّة","jannah","Paradise"], ["أَذَان","adhān","Call to prayer"],
    ["نَار","nār","Fire"], ["نَهْر","nahr","River"], ["نَجْم","najm","Star"], ["إِنسَان","insān","Human being"],
  ]],
  ["ه","Hāʼ","h","ه","هـ","ـهـ","ـه",[
    ["هُدَى","hudā","Guidance"], ["هَذَا","hādhā","This (m.)"], ["فَهْم","fahm","Understanding"], ["وَجْه","wajh","Face"],
    ["هَوَاء","hawā'","Air"], ["هِلَال","hilāl","Crescent"], ["مِنْهَاج","minhāj","Method"], ["أَهْل","ahl","Family"],
  ]],
  ["و","Wāw","w / ū","و","و","ـو","ـو",[
    ["وَقْت","waqt","Time"], ["وَالِد","wālid","Father"], ["نُور","nūr","Light"], ["دُعَاء","duʿā'","Supplication"],
    ["وَرْدَة","wardah","Rose"], ["وَادِي","wādī","Valley"], ["وَضُوء","wuḍū'","Ablution"], ["يَوْم","yawm","Day"],
  ]],
  ["ي","Yāʼ","y / ī","ي","يـ","ـيـ","ـي",[
    ["يَوْم","yawm","Day"], ["يَد","yad","Hand"], ["بَيْت","bayt","House"], ["نَبِيّ","nabiyy","Prophet"],
    ["يَمِين","yamīn","Right (hand)"], ["يَتِيم","yatīm","Orphan"], ["زَيْت","zayt","Oil"], ["حَدِيث","ḥadīth","Ḥadīth"],
  ]],
];

// ─── Similar-sounding letter drills (the classic trainer for non-Arab speakers) ─
// Each pair contrasts two letters that English speakers often confuse.
export const SIMILAR_PAIRS = [
  { pair: ["ت","ط"], names: ["Tāʼ","Ṭāʼ"], hint: "Light 't' vs heavy 't' — jaw drops for ط.",
    examples: [["تَاب","ṭāb","tāba (he repented) — ṭāba (he was good)"],["تِين","طِين","tīn (fig) — ṭīn (mud)"],["تَعَام","طَعَام","taʿām (— non-word) — ṭaʿām (food)"]] },
  { pair: ["س","ص"], names: ["Sīn","Ṣād"], hint: "Light 's' vs heavy emphatic 's' — jaw drops for ص.",
    examples: [["سَبَر","صَبَر","sabara (he probed) — ṣabara (he was patient)"],["سَيْف","صَيْف","sayf (sword) — ṣayf (summer)"],["مَسِير","مَصِير","masīr (journey) — maṣīr (destiny)"]] },
  { pair: ["د","ض"], names: ["Dāl","Ḍād"], hint: "Light 'd' vs heavy 'ḍ' — the letter unique to Arabic.",
    examples: [["دَاع","ضَاع","dāʿa (he called) — ḍāʿa (he lost)"],["دَرْب","ضَرْب","darb (path) — ḍarb (striking)"],["فَادَ","فَاضَ","fāda (he benefited) — fāḍa (it overflowed)"]] },
  { pair: ["ذ","ظ"], names: ["Dhāl","Ẓāʼ"], hint: "Light 'dh' (like 'this') vs heavy emphatic version.",
    examples: [["ذَلَّ","ظَلَّ","dhalla (he was humbled) — ẓalla (he continued)"],["ذَنّ","ظَنّ","dhann (— non-word) — ẓann (assumption)"],["نَذَر","نَظَر","nadhara (he vowed) — naẓara (he looked)"]] },
  { pair: ["ح","ه"], names: ["Ḥāʼ","Hāʼ"], hint: "Deep chest-throat 'ḥ' vs light English 'h'.",
    examples: [["حَلّ","هَلّ","ḥalla (he solved) — halla (he appeared)"],["حَامِد","هَامِد","ḥāmid (praising) — hāmid (subsided)"],["سَحَل","سَهَل","saḥala (he ground) — sahala (it became easy)"]] },
  { pair: ["ك","ق"], names: ["Kāf","Qāf"], hint: "Front-of-mouth 'k' vs back-of-throat 'q'.",
    examples: [["كَلْب","قَلْب","kalb (dog) — qalb (heart)"],["كَال","قَال","kāla (he measured) — qāla (he said)"],["كَبْر","قَبْر","kabr (— non-word) — qabr (grave)"]] },
  { pair: ["ث","س","ص"], names: ["Thāʼ","Sīn","Ṣād"], hint: "Three sibilants — soft 'th' vs light 's' vs heavy 'ṣ'.",
    examples: [["ثَام","سَام","ṯām — sāma (he asked a price)"],["ثَلْج","سَلْج","thalj (snow) — salj (— non-word)"],["نَاث","نَاس","nāth (— non-word) — nās (people)"]] },
  { pair: ["ع","ء"], names: ["ʿAyn","Hamza"], hint: "Throat-open 'ʿ' vs glottal stop 'ʼ'.",
    examples: [["عَام","آم","ʿām (year) — ām (— non-word)"],["سَعَل","سَأَل","saʿala (he coughed) — sa'ala (he asked)"],["دَعَا","دَأَا","daʿā (he called) — dā'a (— non-word)"]] },
  { pair: ["غ","خ"], names: ["Ghayn","Khāʼ"], hint: "Voiced gargle 'gh' vs unvoiced rasp 'kh'.",
    examples: [["غَال","خَال","ghāla (he became dear) — khāl (uncle)"],["غَبَر","خَبَر","ghabara (he dusted) — khabara (news)"],["بَغَل","بَخَل","baghala (— non-word) — bakhala (he was miserly)"]] },
];

// ─── Reading drills — connected two-word phrases (Madinah Book 1 style) ────
export const READING_DRILLS = [
  ["هَذَا بَيْتٌ", "hādhā baytun", "This is a house."],
  ["هَذَا بَابٌ", "hādhā bābun", "This is a door."],
  ["هَذَا مَسْجِدٌ", "hādhā masjidun", "This is a mosque."],
  ["ذَلِكَ رَجُلٌ", "dhālika rajulun", "That is a man."],
  ["ذَلِكَ كِتَابٌ", "dhālika kitābun", "That is a book."],
  ["تِلْكَ سَيَّارَةٌ", "tilka sayyārah", "That is a car."],
  ["مَنْ هَذَا؟", "man hādhā?", "Who is this?"],
  ["مَا هَذَا؟", "mā hādhā?", "What is this?"],
  ["الْبَيْتُ كَبِيرٌ", "al-baytu kabīr", "The house is big."],
  ["الْقَلَمُ عَلَى الْكِتَابِ", "al-qalamu ʿalā l-kitāb", "The pen is on the book."],
  ["الْمُدَرِّسُ فِي الْفَصْلِ", "al-mudarrisu fī l-faṣl", "The teacher is in the classroom."],
  ["الطَّالِبُ فِي الْمَسْجِدِ", "aṭ-ṭālibu fī l-masjid", "The student is in the mosque."],
  ["أَنَا مُسْلِمٌ", "anā muslim", "I am a Muslim."],
  ["أَنْتَ طَبِيبٌ", "anta ṭabīb", "You are a doctor."],
  ["نَحْنُ نَقْرَأُ الْقُرْآنَ", "naḥnu naqra' l-qur'ān", "We are reading the Qur'an."],
  ["الْأَبُ فِي الْبَيْتِ وَالْأُمُّ فِي الْحَدِيقَةِ", "al-abu fī l-bayt wa-l-ummu fī l-ḥadīqah", "The father is in the house and the mother is in the garden."],
];

// ─── Harakāt with 3 examples each ───────────────────────────────────────
export const HARAKAT = [
  { name: "Fatḥah", tr: "a", note: "Short 'a' — a small dash above the letter.",
    examples: [["بَ","ba"],["دَ","da"],["كَ","ka"],["جَبَل","jabal"]] },
  { name: "Kasrah", tr: "i", note: "Short 'i' — a small dash below the letter.",
    examples: [["بِ","bi"],["دِ","di"],["كِ","ki"],["مِن","min"]] },
  { name: "Ḍammah", tr: "u", note: "Short 'u' — a small waw above the letter.",
    examples: [["بُ","bu"],["دُ","du"],["كُ","ku"],["كُنْ","kun"]] },
  { name: "Sukūn", tr: "—", note: "No vowel — the letter is silent / closes the syllable.",
    examples: [["بْ","b"],["دْ","d"],["كْ","k"],["مَسْجِد","masjid"]] },
  { name: "Fatḥatān", tr: "an", note: "Tanwīn fatḥ — indefinite '-an' ending.",
    examples: [["بًا","ban"],["دًا","dan"],["كِتَابًا","kitāban"],["شُكْرًا","shukran"]] },
  { name: "Kasratān", tr: "in", note: "Tanwīn kasr — indefinite '-in' ending.",
    examples: [["بٍ","bin"],["دٍ","din"],["بَيْتٍ","baytin"],["كِتَابٍ","kitābin"]] },
  { name: "Ḍammatān", tr: "un", note: "Tanwīn ḍamm — indefinite '-un' ending.",
    examples: [["بٌ","bun"],["دٌ","dun"],["بَيْتٌ","baytun"],["كِتَابٌ","kitābun"]] },
  { name: "Shaddah", tr: "◌ּ", note: "Doubles the letter — sits above.",
    examples: [["بَّ","bba"],["رَبّ","rabb"],["إِنَّ","inna"],["اللَّهُ","allāh"]] },
];

// ─── Top-frequency Qur'an words ─────────────────────────────────────────
export const WORDS = [
  { ar:"ٱللَّهُ", tr:"Allāh", en:"Allah" }, { ar:"رَبّ", tr:"Rabb", en:"Lord" },
  { ar:"ٱلرَّحْمَـٰنِ", tr:"ar-Raḥmān", en:"The Most Merciful" },
  { ar:"ٱلرَّحِيمِ", tr:"ar-Raḥīm", en:"The Especially Merciful" },
  { ar:"ٱلْحَمْدُ", tr:"al-ḥamdu", en:"All praise" }, { ar:"قُلْ", tr:"qul", en:"Say" },
  { ar:"قَالَ", tr:"qāla", en:"He said" }, { ar:"كَانَ", tr:"kāna", en:"He was" },
  { ar:"مِن", tr:"min", en:"From" }, { ar:"إِلَى", tr:"ilā", en:"To" },
  { ar:"فِي", tr:"fī", en:"In" }, { ar:"عَلَىٰ", tr:"ʿalā", en:"On" },
  { ar:"مَا", tr:"mā", en:"What / not" }, { ar:"لَا", tr:"lā", en:"No / not" },
  { ar:"إِنَّ", tr:"inna", en:"Indeed" }, { ar:"هُوَ", tr:"huwa", en:"He" },
  { ar:"هِيَ", tr:"hiya", en:"She" }, { ar:"أَنتَ", tr:"anta", en:"You (m.)" },
  { ar:"نَحْنُ", tr:"naḥnu", en:"We" }, { ar:"بِٱسْمِ", tr:"bismi", en:"In the name of" },
  { ar:"يَوْمَ", tr:"yawma", en:"Day" }, { ar:"ٱلْأَرْضِ", tr:"al-arḍ", en:"The earth" },
  { ar:"ٱلسَّمَاءِ", tr:"as-samā'", en:"The sky" }, { ar:"كِتَابٌ", tr:"kitāb", en:"Book" },
  { ar:"ءَامَنُوا۟", tr:"āmanū", en:"They believed" },
  { ar:"ٱتَّقُوا۟", tr:"ittaqū", en:"Have taqwā" },
  { ar:"ٱعْبُدُوا۟", tr:"uʿbudū", en:"Worship!" },
  { ar:"صَلَاةَ", tr:"ṣalāh", en:"Prayer" }, { ar:"زَكَاةَ", tr:"zakāh", en:"Zakāt" },
  { ar:"جَنَّةٍ", tr:"jannah", en:"Garden / paradise" },
];

// ─── Detached pronouns ─────────────────────────────────────────────────
export const PRONOUNS = [
  { ar:"أَنَا", tr:"anā", en:"I" }, { ar:"نَحْنُ", tr:"naḥnu", en:"We" },
  { ar:"أَنْتَ", tr:"anta", en:"You (m. singular)" },
  { ar:"أَنْتِ", tr:"anti", en:"You (f. singular)" },
  { ar:"أَنْتُمَا", tr:"antumā", en:"You two" },
  { ar:"أَنْتُمْ", tr:"antum", en:"You (m. plural)" },
  { ar:"أَنْتُنَّ", tr:"antunna", en:"You (f. plural)" },
  { ar:"هُوَ", tr:"huwa", en:"He" }, { ar:"هِيَ", tr:"hiya", en:"She" },
  { ar:"هُمَا", tr:"humā", en:"They two" },
  { ar:"هُمْ", tr:"hum", en:"They (m.)" },
  { ar:"هُنَّ", tr:"hunna", en:"They (f.)" },
];

export const SUN_LETTERS  = ["ت","ث","د","ذ","ر","ز","س","ش","ص","ض","ط","ظ","ل","ن"];
export const MOON_LETTERS = ["ا","ب","ج","ح","خ","ع","غ","ف","ق","ك","م","ه","و","ي"];

// ─── Verb conjugation — SIX common verbs, past + present, across 8 persons ─
const _persons = [
  { subject:"هُوَ (He)"        },
  { subject:"هِيَ (She)"       },
  { subject:"أَنْتَ (You m.)"  },
  { subject:"أَنْتِ (You f.)"  },
  { subject:"أَنَا (I)"        },
  { subject:"نَحْنُ (We)"      },
  { subject:"هُمْ (They m.)"   },
  { subject:"هُنَّ (They f.)"  },
];

export const VERBS = [
  {
    root: "ك-ت-ب", english: "to write", past3ms: "كَتَبَ",
    rows: _persons.map((p, i) => ({ ...p, past: ["كَتَبَ","كَتَبَتْ","كَتَبْتَ","كَتَبْتِ","كَتَبْتُ","كَتَبْنَا","كَتَبُوا","كَتَبْنَ"][i],
      present: ["يَكْتُبُ","تَكْتُبُ","تَكْتُبُ","تَكْتُبِينَ","أَكْتُبُ","نَكْتُبُ","يَكْتُبُونَ","يَكْتُبْنَ"][i] })),
  },
  {
    root: "ق-ر-أ", english: "to read", past3ms: "قَرَأَ",
    rows: _persons.map((p, i) => ({ ...p, past: ["قَرَأَ","قَرَأَتْ","قَرَأْتَ","قَرَأْتِ","قَرَأْتُ","قَرَأْنَا","قَرَأُوا","قَرَأْنَ"][i],
      present: ["يَقْرَأُ","تَقْرَأُ","تَقْرَأُ","تَقْرَئِينَ","أَقْرَأُ","نَقْرَأُ","يَقْرَأُونَ","يَقْرَأْنَ"][i] })),
  },
  {
    root: "س-م-ع", english: "to hear", past3ms: "سَمِعَ",
    rows: _persons.map((p, i) => ({ ...p, past: ["سَمِعَ","سَمِعَتْ","سَمِعْتَ","سَمِعْتِ","سَمِعْتُ","سَمِعْنَا","سَمِعُوا","سَمِعْنَ"][i],
      present: ["يَسْمَعُ","تَسْمَعُ","تَسْمَعُ","تَسْمَعِينَ","أَسْمَعُ","نَسْمَعُ","يَسْمَعُونَ","يَسْمَعْنَ"][i] })),
  },
  {
    root: "ذ-ه-ب", english: "to go", past3ms: "ذَهَبَ",
    rows: _persons.map((p, i) => ({ ...p, past: ["ذَهَبَ","ذَهَبَتْ","ذَهَبْتَ","ذَهَبْتِ","ذَهَبْتُ","ذَهَبْنَا","ذَهَبُوا","ذَهَبْنَ"][i],
      present: ["يَذْهَبُ","تَذْهَبُ","تَذْهَبُ","تَذْهَبِينَ","أَذْهَبُ","نَذْهَبُ","يَذْهَبُونَ","يَذْهَبْنَ"][i] })),
  },
  {
    root: "ع-ل-م", english: "to know", past3ms: "عَلِمَ",
    rows: _persons.map((p, i) => ({ ...p, past: ["عَلِمَ","عَلِمَتْ","عَلِمْتَ","عَلِمْتِ","عَلِمْتُ","عَلِمْنَا","عَلِمُوا","عَلِمْنَ"][i],
      present: ["يَعْلَمُ","تَعْلَمُ","تَعْلَمُ","تَعْلَمِينَ","أَعْلَمُ","نَعْلَمُ","يَعْلَمُونَ","يَعْلَمْنَ"][i] })),
  },
  {
    root: "ف-ع-ل", english: "to do / make", past3ms: "فَعَلَ",
    rows: _persons.map((p, i) => ({ ...p, past: ["فَعَلَ","فَعَلَتْ","فَعَلْتَ","فَعَلْتِ","فَعَلْتُ","فَعَلْنَا","فَعَلُوا","فَعَلْنَ"][i],
      present: ["يَفْعَلُ","تَفْعَلُ","تَفْعَلُ","تَفْعَلِينَ","أَفْعَلُ","نَفْعَلُ","يَفْعَلُونَ","يَفْعَلْنَ"][i] })),
  },
];

// ─── Sentences (nominal + verbal) with iʿrāb notes ──────────────────────
export const SENTENCES = [
  // Nominal (start with a noun)
  { ar:"ٱلْبَيْتُ كَبِيرٌ", tr:"al-baytu kabīr", en:"The house is big.",
    note:"Nominal — mubtada' (البيتُ) + khabar (كبيرٌ). No verb 'to be'." },
  { ar:"ٱلْكِتَابُ جَدِيدٌ", tr:"al-kitābu jadīd", en:"The book is new.",
    note:"Nominal — same pattern with a new noun-adjective pair." },
  { ar:"ٱلطَّالِبُ فِي ٱلْمَسْجِدِ", tr:"aṭ-ṭālibu fī l-masjidi", en:"The student is in the mosque.",
    note:"Preposition (فِي) governs kasrah on the noun after it." },
  { ar:"هَذَا بَابٌ", tr:"hādhā bāb", en:"This is a door.",
    note:"Demonstrative (هَذَا) + indefinite noun with tanwīn ḍamm." },
  { ar:"تِلْكَ مَدْرَسَةٌ", tr:"tilka madrasah", en:"That is a school.",
    note:"Feminine far demonstrative (تِلْكَ) — ة on مدرسة marks feminine." },
  { ar:"أَنَا مُسْلِمٌ", tr:"anā muslim", en:"I am a Muslim.",
    note:"Pronoun (أنا) as mubtada'; predicate is indefinite masculine." },
  { ar:"أَنْتِ طَبِيبَةٌ", tr:"anti ṭabībah", en:"You (f.) are a doctor.",
    note:"Feminine 2nd-person pronoun + feminine noun (ة ending)." },
  { ar:"لِلَّهِ ٱلْحَمْدُ", tr:"lillāhi l-ḥamd", en:"To Allah is all praise.",
    note:"Fronted prepositional phrase (لِلَّهِ) as khabar — mubtada' comes after." },

  // Verbal (start with a verb)
  { ar:"قَرَأَ ٱلْوَلَدُ ٱلْقُرْآنَ", tr:"qara'a l-waladu l-qur'āna", en:"The boy read the Qur'an.",
    note:"Verbal — fi'l (قَرَأَ) + fā'il (الولدُ) + maf'ūl bihi (القرآنَ)." },
  { ar:"كَتَبَ ٱلطَّالِبُ ٱلدَّرْسَ", tr:"kataba ṭ-ṭālibu d-darsa", en:"The student wrote the lesson.",
    note:"Same verbal pattern with a different verb + object." },
  { ar:"ذَهَبْنَا إِلَى ٱلْمَسْجِدِ", tr:"dhahabnā ilā l-masjidi", en:"We went to the mosque.",
    note:"Verb + prepositional phrase — no explicit object." },
  { ar:"يَسْمَعُ ٱلْمُؤْمِنُ ٱلْأَذَانَ", tr:"yasmaʿu l-mu'minu l-adhāna", en:"The believer hears the adhān.",
    note:"Present-tense verbal sentence — same subject-object structure." },
  { ar:"لَا إِلَـٰهَ إِلَّا ٱللَّهُ", tr:"lā ilāha illā llāh", en:"There is no god but Allah.",
    note:"Absolute negation with لَا — famously the shahādah." },
  { ar:"مَا هَذَا كِتَابًا", tr:"mā hādhā kitāban", en:"This is not a book.",
    note:"Negation of a nominal sentence using مَا — predicate becomes منصوب." },
  { ar:"أَيْنَ ٱلطَّرِيقُ؟", tr:"ayna ṭ-ṭarīq?", en:"Where is the road?",
    note:"Question word (أَيْنَ) — no verb needed for present-tense 'to be'." },
];

// ─── Prepositions (ḥurūf al-jarr) — many examples ──────────────────────
export const PREPOSITIONS = [
  { ar:"فِي", tr:"fī", en:"in / inside",
    examples:[["فِي الْبَيْتِ","fī l-bayt","in the house"],["فِي الْمَسْجِدِ","fī l-masjid","in the mosque"],["فِي الْكِتَابِ","fī l-kitāb","in the book"]] },
  { ar:"عَلَىٰ", tr:"ʿalā", en:"on / upon",
    examples:[["عَلَى الطَّرِيقِ","ʿalā ṭ-ṭarīq","on the road"],["عَلَى الْمَكْتَبِ","ʿalā l-maktab","on the desk"],["عَلَى الشَّجَرَةِ","ʿalā sh-shajarah","on the tree"]] },
  { ar:"مِنْ", tr:"min", en:"from",
    examples:[["مِنَ الْبَيْتِ","mina l-bayt","from the house"],["مِنَ السَّمَاءِ","mina s-samā'","from the sky"],["مِنْ مَكَّةَ","min makkata","from Makkah"]] },
  { ar:"إِلَىٰ", tr:"ilā", en:"to / towards",
    examples:[["إِلَى الْمَسْجِدِ","ilā l-masjid","to the mosque"],["إِلَى الْمَدْرَسَةِ","ilā l-madrasah","to the school"],["إِلَيَّ","ilayya","to me"]] },
  { ar:"عَنْ", tr:"ʿan", en:"from / about",
    examples:[["عَنِ ٱلنَّبِيِّ ﷺ","ʿani n-nabiyy","from the Prophet ﷺ"],["عَنْكَ","ʿanka","about you"],["عَنْ الْكِتَابِ","ʿan al-kitāb","about the book"]] },
  { ar:"بِـ", tr:"bi-", en:"with / by / in",
    examples:[["بِسْمِ ٱللَّهِ","bismillāh","in the name of Allah"],["بِالْقَلَمِ","bi-l-qalam","with the pen"],["بِاللَّيْلِ","bi-l-layl","at night"]] },
  { ar:"لِـ", tr:"li-", en:"for / to / belonging to",
    examples:[["لِلَّهِ","lillāhi","for Allah"],["لِي","lī","for me"],["لِلطَّالِبِ","liṭ-ṭālib","for the student"]] },
  { ar:"كَـ", tr:"ka-", en:"like / as",
    examples:[["كَالْقَمَرِ","ka-l-qamar","like the moon"],["كَذَٰلِكَ","ka-dhālika","like that"],["كَالْمَاءِ","ka-l-mā'","like water"]] },
  { ar:"مَعَ", tr:"maʿa", en:"with (together with)",
    examples:[["مَعَ ٱلصَّابِرِينَ","maʿa ṣ-ṣābirīn","with the patient ones"],["مَعِي","maʿī","with me"],["مَعَ ٱلطُّلَّابِ","maʿa ṭ-ṭullāb","with the students"]] },
];

// ─── Particles: interrogatives, negation, conjunctions ─────────────────
export const PARTICLES = {
  interrogatives: [
    { ar:"مَا", tr:"mā", en:"What (for things)", ex:["مَا اسْمُكَ؟","mā ismuka?","What is your name?"] },
    { ar:"مَنْ", tr:"man", en:"Who", ex:["مَنْ هَذَا؟","man hādhā?","Who is this?"] },
    { ar:"أَيْنَ", tr:"ayna", en:"Where", ex:["أَيْنَ الْمَسْجِدُ؟","ayna l-masjid?","Where is the mosque?"] },
    { ar:"مَتَىٰ", tr:"matā", en:"When", ex:["مَتَى الصَّلَاةُ؟","matā ṣ-ṣalāh?","When is the prayer?"] },
    { ar:"كَيْفَ", tr:"kayfa", en:"How", ex:["كَيْفَ حَالُكَ؟","kayfa ḥāluk?","How are you?"] },
    { ar:"لِمَاذَا", tr:"limādhā", en:"Why", ex:["لِمَاذَا؟","limādhā?","Why?"] },
    { ar:"كَمْ", tr:"kam", en:"How many", ex:["كَمْ سَاعَةً؟","kam sāʿah?","How many hours?"] },
    { ar:"هَلْ", tr:"hal", en:"Yes/No question marker", ex:["هَلْ أَنْتَ مُسْلِمٌ؟","hal anta muslim?","Are you a Muslim?"] },
  ],
  negation: [
    { ar:"لَا", tr:"lā", en:"Not (present + generic)", ex:["لَا أَعْلَمُ","lā aʿlamu","I do not know"] },
    { ar:"لَمْ", tr:"lam", en:"Did not (past — with jussive)", ex:["لَمْ يَذْهَبْ","lam yadhhab","He did not go"] },
    { ar:"لَنْ", tr:"lan", en:"Will not (future — with subjunctive)", ex:["لَنْ أَذْهَبَ","lan adhhaba","I will not go"] },
    { ar:"مَا", tr:"mā", en:"Not (past — nominal)", ex:["مَا فَعَلَ","mā faʿala","He did not do"] },
    { ar:"لَيْسَ", tr:"laysa", en:"Is not (verb of negation)", ex:["لَيْسَ كَبِيرًا","laysa kabīran","He is not big"] },
  ],
  conjunctions: [
    { ar:"وَ", tr:"wa-", en:"And", ex:["الْبَيْتُ وَالْمَسْجِدُ","al-baytu wa-l-masjid","the house and the mosque"] },
    { ar:"فَ", tr:"fa-", en:"So / then", ex:["قَرَأَ فَفَهِمَ","qara'a fa-fahima","he read, so he understood"] },
    { ar:"ثُمَّ", tr:"thumma", en:"Then (later)", ex:["أَكَلَ ثُمَّ نَامَ","akala thumma nāma","he ate then slept"] },
    { ar:"أَوْ", tr:"aw", en:"Or", ex:["الشَّايُ أَوِ الْقَهْوَةُ","ash-shāy aw al-qahwah","tea or coffee"] },
    { ar:"لَكِنْ", tr:"lākin", en:"But", ex:["صَغِيرٌ لَكِنْ جَمِيلٌ","ṣaghīr lākin jamīl","small but beautiful"] },
    { ar:"لِأَنَّ", tr:"li-anna", en:"Because", ex:["نَقْرَأُ لِأَنَّنَا نُحِبُّ الْعِلْمَ","naqra' li-annanā nuḥibbu l-ʿilm","we read because we love knowledge"] },
  ],
};
